import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';
import _ from 'lodash';
import { LOCATION_MAP } from '../../constants/constants';

//- Actions
export const fetchGetCountriesFailed = createAction('FETCH_GET_COUNTRIES_FAILED');
export const fetchGetCountriesSuccess = createAction('FETCH_GET_COUNTRIES_SUCCESS');
export const fetchGetCountries = createAction(
    'FETCH_GET_COUNTRIES',
    () => Api.getCountries(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetCountriesSuccess,
        onFail: fetchGetCountriesFailed
    })
);
export const setCurrentContinent = createAction('SET_CURRENT_CONTINENT');
export const setCurrentContinentByCountry = (countryCode) => (dispatch, getState) => {
    dispatch(setCurrentContinent(getContinentByCountry(countryCode, getState())));
};

//- State
const initialState = {
    data: null,
    currentContinent: "",
    error: null,
    fetching: false
};

//- Reducers
export default handleActions({

    FETCH_GET_COUNTRIES: (state) => {
        return { ...state, data: null, error: null, fetching: true };
    },
    FETCH_GET_COUNTRIES_FAILED: (state, action) => {
        return { ...state, data: null, error: action.payload, fetching: false };
    },
    FETCH_GET_COUNTRIES_SUCCESS: (state, action) => {
        let countries = action.payload;
        let data = {};
        _.mapValues(LOCATION_MAP, (value, key) => {
            let newValue = value.filter((elem) => countries.includes(elem));
            data[key] = newValue;
        });
        return { ...state, data: data, error: null, fetching: false };
    },
    SET_CURRENT_CONTINENT: (state, action) => {
        return { ...state, currentContinent: action.payload };
    },
    SET_CURRENT_CONTINENT_BY_COUNTRY: (state, action) => {

        return { ...state, currentContinent: action.payload };
    }

}, initialState);


//- Selectors
export const getLocation = state => state.location;

export const getLocationData = state => getLocation(state).data;

export const getCurrentContinent = state => getLocation(state).currentContinent;

export const getContinentsData = (state) => {
    if (_.isNil(getLocationData(state))) {
        return [];
    }
    return _.keys(getLocationData(state));
};

export const getCountriesData = (state) => {
    if (_.isNil(getLocationData(state))) {
        return [];
    }
    return getLocationData(state)[getCurrentContinent(state)];
};

export const getContinentByCountry = (countryCode, state) => {
    let data = getLocationData(state);
    return _.keys(getLocationData(state)).find((key) => {
        return data[key].includes(countryCode);
    });
};


// WEBPACK FOOTER //
// ./src/reducers/common/location.js